import { render, staticRenderFns } from "./ExpenseAdmin.vue?vue&type=template&id=121f6b33&"
import script from "./ExpenseAdmin.vue?vue&type=script&lang=js&"
export * from "./ExpenseAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports